import type { AxiosInstance, AxiosRequestConfig } from "axios";

type AccessTokenGetter = () => string | undefined;

let accessTokenGetter: AccessTokenGetter = () => undefined;
const configuredInstances = new WeakSet<AxiosInstance>();

export function setAccessTokenGetter(getter: AccessTokenGetter) {
  accessTokenGetter = getter;
}

function attachAuthHeader(config: AxiosRequestConfig) {
  const token = accessTokenGetter();

  if (token) {
    if (!config.headers) {
      config.headers = {};
    }
    config.headers.Authorization = `Bearer ${token}`;
  } else if (config.headers) {
    delete config.headers.Authorization;
    delete config.headers.authorization;
  }

  return config;
}

export function setupApiAuthInterceptor(api: AxiosInstance) {
  if (configuredInstances.has(api)) {
    return;
  }

  api.interceptors.request.use(attachAuthHeader);
  configuredInstances.add(api);
}
